import * as THREE from 'three';

export const services = [
  {
    id: 'promo',
    title: 'Promo Videos',
    position: new THREE.Vector3(-3, 1.5, 0),
    description: `
      <p>Our promotional videos are designed to create an immediate impact, delivering your message with cinematic quality that captures attention and drives engagement.</p>
      <p>From product launches to brand awareness campaigns, we create videos that not only inform but inspire action.</p>
      <h3>Features:</h3>
      <ul>
        <li>High-end visual aesthetics</li>
        <li>Strategic storytelling</li>
        <li>Platform-optimized delivery</li>
        <li>Performance-focused content</li>
      </ul>
    `
  },
  {
    id: 'music',
    title: 'Music Videos',
    position: new THREE.Vector3(0, 3, -3),
    description: `
      <p>We collaborate with artists to create visually stunning music videos that complement and enhance their musical vision.</p>
      <p>Our team combines creative direction, cinematography, and cutting-edge visual effects to produce videos that resonate with audiences and extend the artist's brand.</p>
      <h3>Capabilities:</h3>
      <ul>
        <li>Concept development</li>
        <li>Visual storytelling</li>
        <li>Performance direction</li>
        <li>Post-production excellence</li>
      </ul>
    `
  },
  {
    id: 'corporate',
    title: 'Corporate Films',
    position: new THREE.Vector3(3, 1.5, 0),
    description: `
      <p>Our corporate videos communicate your company's message with clarity and sophistication, whether for internal communications, training, or public-facing content.</p>
      <p>We understand business objectives and translate them into compelling visual narratives that engage your target audience.</p>
      <h3>Services Include:</h3>
      <ul>
        <li>Company profiles and brand stories</li>
        <li>Executive interviews and testimonials</li>
        <li>Product demonstrations</li>
        <li>Event documentation</li>
      </ul>
    `
  },
  {
    id: 'film',
    title: 'Film Production',
    position: new THREE.Vector3(0, 0, 3),
    description: `
      <p>Our film production services bring your creative vision to life with cinematic quality and storytelling excellence.</p>
      <p>From short films to feature-length productions, we handle every aspect of the filmmaking process with attention to detail and artistic integrity.</p>
      <h3>Our Process:</h3>
      <ul>
        <li>Script development and pre-production</li>
        <li>Full production services</li>
        <li>Advanced cinematography</li>
        <li>Post-production and color grading</li>
      </ul>
    `
  }
];

export const getColorForService = (id) => {
  switch(id) {
    case 'promo':
      return 0x00eeff;
    case 'music':
      return 0xff00aa;
    case 'corporate':
      return 0xffaa00;
    case 'film':
      return 0x00ff88;
    default:
      return 0xffffff;
  }
};